//艺术家主页接口
import states from '../state/pageProduct';
import mutations from '../mutations/pageProduct';
import actions from '../actions/pageProduct';
import getters from '../getters/pageProduct';

export default {
    namespaced: true,
    states,
    mutations,
    actions,
    getters
};